import request from '@/config/axios'

export const getInvoicePage = (params: any) => request.get({ url: '/rental/invoice/page', params })
export const issueInvoice = (data: { id: number; invoiceNo?: string }) =>
  request.put({ url: '/rental/invoice/issue', data })
